import React from 'react';
import styled from '@emotion/styled';
import { Box, Container, Grid, useTheme, useMediaQuery, IconButton, Snackbar, Alert } from '@mui/material';
import { FiCopy } from 'react-icons/fi';
import Affiliate from '../../../assets/Affiliate.svg';
import Staking from '../../../assets/Staking.svg';
import Revenue from '../../../assets/Revenue.svg';
import Platform from '../../../assets/Platform.svg';
import Backs from '../../../assets/Backs.svg';
import aicmcoin from '../../../assets/aicmcoin.png';
import Ads from '../../../assets/Ads.svg';
import Heading from '../../Components/LockerMenu/component/Heading';
import copy from '../../../assets/Copy.svg';
import Paragraph from '../../Components/LockerMenu/component/Paragraph';

const Wrapper = styled(Box)`
    padding: 80px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    position: relative;
`;

const AddressContainer = styled(Box)`
    display: flex;
    align-items: center;
    background-color: #fff;
    padding: 12px 14px;
    border-radius: 8px;
    color: #000;
    gap: 8px;
    margin-bottom: 10px;
    width: 100%;
    max-width: 200px;
    font-size: 14px;
    box-shadow: 0px 2px 67px rgba(0, 0, 0, 0.1), 
                0px 1px 2px rgba(0, 0, 0, 0.08);
    transition: box-shadow 0.2s ease;
    
    @media (max-width: 600px) {
        font-size: 12px;
        padding: 10px;
        justify-content: space-between;
        max-width: 240px;
        margin: 0 auto 20px auto;
    } 
`;

const ColorBox = styled(Box)`
  width: 100%;
  max-width: 250px;
  display: flex;
  color: #030930;
  align-items: center;
  padding: 10px;
  gap: 20px;
  border: 3px solid #CFE5FF;
  border-radius: 12px;
  font-size: 17px;
  font-weight: 550;
  background: #F4FAFF;
  
  @media (max-width: 600px) {
    max-width: 170px;
    font-size: 15px;
    margin: 0 auto;
  }
`;

const UtilityGrid = styled(Grid)`
  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

const ColorBoxContainer = styled('div')`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 10px;
  
  @media (max-width: 600px) {
    justify-content: center;
    width: 100%;
  }
`;

const TokenUtility = () => {
    const theme = useTheme(); 
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); 
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    
    const fullContractAddress = "0x87904bE82BC1C29E94a0b99474d183B4e08a7E47";
    const truncatedContractAddress = "0x8790...08a7E47";  

    const [open, setOpen] = React.useState(false);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(fullContractAddress);  
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    return (
        <Wrapper>
            <Container maxWidth="lg">
                <Grid container  justifyContent="center" alignItems="center" spacing={isMobile ? 4 : 6}>
                    <UtilityGrid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
                        <AddressContainer>
                            {truncatedContractAddress}  
                            <IconButton onClick={copyToClipboard} size="small" sx={{ padding: '4px' }}>
                                <img src={copy} alt='copy' draggable='false'/>
                            </IconButton>
                        </AddressContainer>
                        
                        <Snackbar open={open}
                            autoHideDuration={3000}
                            onClose={handleClose}
                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                            <Alert onClose={handleClose} severity="success" sx={{ width: '100%', backgroundColor:'#000' }}>
                                Address copied to clipboard!
                            </Alert>
                        </Snackbar>
                        
                        <Heading style={{ marginBottom: '10px', textAlign: isMobile ? 'center' : 'left' }}>
                            Token Utility
                        </Heading>
                        <Paragraph style={{ 
                            opacity: '0.6', 
                            maxWidth: '550px', 
                            marginBottom: '24px', 
                            textAlign: isMobile ? 'center' : 'left',
                            marginLeft: isMobile ? 'auto' : 'inherit',
                            marginRight: isMobile ? 'auto' : 'inherit'
                        }}>
                            Discover how the $AICM token powers transactions, rewards, and exclusive features across our marketplace.
                        </Paragraph>
                        
                        <ColorBoxContainer>
                            <ColorBox><img src={Affiliate} alt="Affiliate" draggable='false'/>Affiliate Program</ColorBox>
                            <ColorBox  style={{ maxWidth: '170px',justifyContent:'space-around' }}><img src={Staking} alt="Staking" draggable='false'/>Staking</ColorBox>
                        </ColorBoxContainer>

                        <ColorBoxContainer>
                            <ColorBox><img src={Revenue} alt="Revenue" draggable='false'/>Revenue Sharing</ColorBox>
                            <ColorBox ><img src={Platform} alt="Platform" draggable='false'/>Platform Payment</ColorBox>
                        </ColorBoxContainer>

                        <ColorBoxContainer>
                            <ColorBox  style={!isMobile ? { maxWidth: '180px' } : {}}><img src={Backs} alt="Backs" draggable='false' />Buy Backs</ColorBox>
                            <ColorBox  style={!isMobile ? { maxWidth: '180px' } : {}}><img src={Ads} alt="Ads" draggable='false'/>Sponsored Ads</ColorBox>
                        </ColorBoxContainer>
                    </UtilityGrid>

                    <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }} sx={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        alignItems: 'center', 
                        padding: isMobile ? '0 0px' : '0',
                        height: '100%'
                    }}>
                        <img src={aicmcoin} 
                            alt="AICM Coin" 
                            style={{
                                alignItems:'center',
                                width: '564px',
                                marginTop:isMobile ? '0px' :'0px' ,
                                maxWidth: isMobile ? '390px' : isTablet ? '500px' : '600px',
                                height: 'auto',
                                maxHeight: isMobile ? '300px' : '500px',
                                objectFit: 'contain'}} draggable="false" />
                    </Grid>
                </Grid>
            </Container>
        </Wrapper>
    );
};

export default TokenUtility;
